(function(){
  if (window.MCProductComparatorLoaded) return;
  window.MCProductComparatorLoaded = true;

  function initComparator(root){
    if (!root || root.dataset.comparatorEnhanced === 'true') return;
    root.dataset.comparatorEnhanced = 'true';

    const dataNode = root.querySelector('[data-comparator-data]');
    if (!dataNode) return;

    let payload;
    try { payload = JSON.parse(dataNode.textContent); } catch (error) { return; }

    const text = (value) => {
      if (value == null) return '';
      if (Array.isArray(value)) return value.map(text).filter(Boolean).join(', ');
      if (typeof value === 'object') {
        if ('value' in value) return [value.value, value.unit].filter(Boolean).join(' ');
        return Object.values(value).map(text).filter(Boolean).join(', ');
      }
      const result = String(value).trim();
      return /^(à renseigner|a renseigner)$/i.test(result) ? '' : result;
    };
    const normalise = (value) => text(value).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const fieldKeys = ['material','length','internalDiameter','ringSizes','weight','closure','openness','discretion','care','experience'];
    const products = [];
    const knownHandles = new Set();

    (payload.products || []).forEach((raw) => {
      const handle = text(raw.handle);
      if (!handle || knownHandles.has(handle)) return;
      const product = {...raw, handle};
      Object.keys(product).forEach((key) => { if (key !== 'priceVaries') product[key] = text(product[key]); });
      products.push(product);
      knownHandles.add(handle);
    });

    const productByHandle = new Map(products.map((product) => [product.handle, product]));
    const cleanHandles = (list) => {
      const clean = [];
      (list || []).forEach((handle) => {
        handle = text(handle);
        if (productByHandle.has(handle) && !clean.includes(handle)) clean.push(handle);
      });
      return clean.slice(0, 3);
    };
    const defaults = cleanHandles(payload.defaults);
    products.forEach((product) => { if (defaults.length < 3 && !defaults.includes(product.handle)) defaults.push(product.handle); });

    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    const storageKey = 'mc-comparator:' + window.location.pathname;
    let requested = [];
    if (!designMode) {
      const fromUrl = new URLSearchParams(window.location.search).get('compare');
      if (fromUrl) requested = cleanHandles(fromUrl.split(','));
      if (!requested.length) {
        try { requested = cleanHandles(JSON.parse(window.localStorage.getItem(storageKey) || '[]')); } catch (error) { requested = []; }
      }
    }

    const state = cleanHandles(requested.length ? requested : defaults);
    defaults.forEach((handle) => { if (state.length < 3 && !state.includes(handle)) state.push(handle); });
    products.forEach((product) => { if (state.length < 3 && !state.includes(product.handle)) state.push(product.handle); });
    while (state.length < 3) state.push(null);

    const layer = root.querySelector('[data-drawer-layer]');
    const drawer = root.querySelector('[data-drawer]');
    const search = root.querySelector('[data-product-search]');
    const list = root.querySelector('[data-product-list]');
    const empty = root.querySelector('[data-product-empty]');
    const resultCount = root.querySelector('[data-result-count]');
    const live = root.querySelector('[data-live-region]');
    const differenceToggle = root.querySelector('[data-differences-only]');
    const cardsRail = root.querySelector('.mc-product-comparator__cards');
    const tableScroll = root.querySelector('.mc-product-comparator__scroll');
    const cardPrevious = root.querySelector('[data-card-previous]');
    const cardNext = root.querySelector('[data-card-next]');
    const cardPosition = root.querySelector('[data-card-position]');
    const tablePrevious = root.querySelector('[data-table-previous]');
    const tableNext = root.querySelector('[data-table-next]');
    const tablePosition = root.querySelector('[data-table-position]');
    let activeSlot = 0;
    let activeFilter = 'all';
    let lastTrigger = null;
    let activeCardPage = 0;
    let activeTablePage = 0;

    const compactMedia = window.matchMedia('(max-width: 749px)');
    const isCompactLayout = () => {
      const visualWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;
      const renderedWidth = root.getBoundingClientRect().width;
      return compactMedia.matches || visualWidth < 750 || renderedWidth < 750 || /(?:\?|&)previewMode=mobile(?:&|$)/.test(window.location.search);
    };
    const syncCompactLayout = () => root.classList.toggle('mc-product-comparator--mobile', isCompactLayout());

    const updateCardNavigation = () => {
      if (cardPosition) cardPosition.textContent = (activeCardPage + 1) + ' / 3';
      if (cardPrevious) cardPrevious.disabled = activeCardPage === 0;
      if (cardNext) cardNext.disabled = activeCardPage === 2;
    };
    const goToCard = (index) => {
      if (!cardsRail) return;
      const cards = Array.from(cardsRail.querySelectorAll('[data-card]'));
      activeCardPage = Math.max(0, Math.min(index, cards.length - 1));
      const target = cards[activeCardPage];
      if (target) cardsRail.scrollTo({ left: target.offsetLeft - cardsRail.offsetLeft, behavior: 'smooth' });
      updateCardNavigation();
    };

    const updateTableNavigation = () => {
      if (tablePosition) tablePosition.textContent = 'Modèle ' + (activeTablePage + 1) + ' / 3';
      if (tablePrevious) tablePrevious.disabled = activeTablePage === 0;
      if (tableNext) tableNext.disabled = activeTablePage === 2;
    };
    const goToTableColumn = (index) => {
      if (!tableScroll) return;
      activeTablePage = Math.max(0, Math.min(index, 2));
      tableScroll.scrollTo({ left: activeTablePage * 224, behavior: 'smooth' });
      updateTableNavigation();
    };

    syncCompactLayout();
    if ('ResizeObserver' in window) new ResizeObserver(syncCompactLayout).observe(root);
    window.addEventListener('resize', syncCompactLayout, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', syncCompactLayout, { passive: true });
    if (cardPrevious) cardPrevious.addEventListener('click', () => goToCard(activeCardPage - 1));
    if (cardNext) cardNext.addEventListener('click', () => goToCard(activeCardPage + 1));
    if (tablePrevious) tablePrevious.addEventListener('click', () => goToTableColumn(activeTablePage - 1));
    if (tableNext) tableNext.addEventListener('click', () => goToTableColumn(activeTablePage + 1));
    if (cardsRail) cardsRail.addEventListener('scroll', () => {
      const cards = Array.from(cardsRail.querySelectorAll('[data-card]'));
      if (!cards.length) return;
      activeCardPage = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - cardsRail.offsetLeft - cardsRail.scrollLeft) < Math.abs(cards[best].offsetLeft - cardsRail.offsetLeft - cardsRail.scrollLeft) ? index : best, 0);
      updateCardNavigation();
    }, { passive: true });
    if (tableScroll) tableScroll.addEventListener('scroll', () => {
      activeTablePage = Math.max(0, Math.min(2, Math.round(tableScroll.scrollLeft / 224)));
      updateTableNavigation();
    }, { passive: true });
    updateCardNavigation();
    updateTableNavigation();

    const productForSlot = (slot) => productByHandle.get(state[slot]) || null;
    const setText = (element, value, fallback = '—') => { if (element) element.textContent = text(value) || fallback; };

    const updateDifferenceRows = () => {
      root.querySelectorAll('[data-compare-row]').forEach((row) => {
        const values = Array.from(row.querySelectorAll('[data-table-field]')).map((cell) => normalise(cell.textContent === '—' ? '' : cell.textContent));
        const allEmpty = values.every((value) => !value);
        const distinct = new Set(values);
        row.hidden = allEmpty || (differenceToggle && differenceToggle.checked && distinct.size <= 1);
      });
      root.querySelectorAll('[data-group-heading]').forEach((heading) => {
        const group = heading.dataset.groupHeading;
        const rows = Array.from(root.querySelectorAll('[data-compare-row][data-group="' + group + '"]'));
        heading.hidden = !rows.some((row) => !row.hidden);
      });
    };

    const render = (announce = false) => {
      for (let slot = 0; slot < 3; slot += 1) {
        const product = productForSlot(slot);
        const card = root.querySelector('[data-card][data-slot="' + slot + '"]');
        if (!card) continue;
        const image = card.querySelector('[data-card-image]');
        const imageLink = card.querySelector('[data-card-image-link]');
        const placeholder = card.querySelector('[data-card-placeholder]');
        const badge = card.querySelector('[data-card-badge]');
        const productLink = card.querySelector('[data-card-product-link]');
        const changeButton = card.querySelector('[data-change-model]');

        setText(card.querySelector('[data-card-title]'), product && product.title, 'Choisissez un modèle');
        setText(card.querySelector('[data-card-price]'), product ? 'À partir de ' + product.price + (product.priceVaries ? ' — selon variante' : '') : '', 'Sélectionnez un produit à comparer');
        setText(card.querySelector('[data-card-summary]'), product && product.shortText, 'Choisissez un modèle pour afficher ses principaux repères.');
        setText(card.querySelector('[data-card-material]'), product && product.material);
        setText(card.querySelector('[data-card-length]'), product && product.length);
        setText(root.querySelector('[data-table-head-slot="' + slot + '"]'), product && product.title, 'Modèle à choisir');

        fieldKeys.forEach((field) => {
          setText(root.querySelector('[data-table-field="' + field + '"][data-slot="' + slot + '"]'), product && product[field]);
        });

        if (product && product.image) {
          image.src = product.image;
          image.alt = product.imageAlt || product.title;
          image.hidden = false;
          imageLink.href = product.url;
          imageLink.setAttribute('aria-label', 'Voir ' + product.title);
          imageLink.hidden = false;
          placeholder.hidden = true;
        } else {
          image.removeAttribute('src');
          image.alt = '';
          image.hidden = true;
          imageLink.hidden = true;
          placeholder.hidden = false;
        }

        if (product && product.badge) {
          badge.textContent = product.badge;
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
        changeButton.textContent = product ? 'Changer ce modèle' : 'Choisir un modèle';

        const tableAction = root.querySelector('[data-table-action-slot="' + slot + '"]');
        [productLink, tableAction].forEach((link) => {
          if (!link) return;
          if (product && product.url) {
            link.href = product.url;
            link.hidden = false;
          } else {
            link.hidden = true;
          }
        });
      }
      updateDifferenceRows();
      if (announce && live) live.textContent = 'Comparaison mise à jour.';
    };

    const filterTerms = {
      metal: ['metal','acier','aluminium','titane'],
      silicone: ['silicone'],
      plastique: ['plastique','polycarbonate','resine','abs'],
      court: ['court','compact','mini'],
      plat: ['plat','plate','flat']
    };
    const matchesNamedFilter = (product, filter) => {
      if (filter === 'all') return true;
      const formatFilter = filter === 'court' || filter === 'plat';
      const source = normalise(formatFilter ? product.format : product.material);
      return (filterTerms[filter] || [filter]).some((term) => source.includes(term));
    };

    const buildChoice = (product) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mc-product-comparator__choice';
      const occupiedElsewhere = state.some((handle, index) => index !== activeSlot && handle === product.handle);
      const current = state[activeSlot] === product.handle;
      button.disabled = occupiedElsewhere || current;
      button.setAttribute('aria-label', current ? product.title + ', modèle actuellement sélectionné' : occupiedElsewhere ? product.title + ', déjà comparé' : 'Comparer ' + product.title);

      if (product.image) {
        const image = document.createElement('img');
        image.src = product.image;
        image.alt = '';
        image.loading = 'lazy';
        button.appendChild(image);
      } else {
        const placeholder = document.createElement('span');
        placeholder.className = 'mc-product-comparator__choice-placeholder';
        placeholder.textContent = 'IMAGE';
        button.appendChild(placeholder);
      }

      const copy = document.createElement('span');
      const title = document.createElement('strong');
      title.textContent = product.title;
      const details = document.createElement('small');
      details.textContent = [product.material, product.format, product.length].filter(Boolean).join(' · ') || 'Caractéristiques à consulter';
      copy.append(title, details);
      button.appendChild(copy);

      const marker = document.createElement('span');
      marker.textContent = current ? '✓' : occupiedElsewhere ? '•' : '→';
      button.appendChild(marker);
      button.addEventListener('click', () => selectProduct(product.handle));
      return button;
    };

    const renderChoices = () => {
      if (!list) return;
      const query = normalise(search && search.value);
      const filtered = products.filter((product) => {
        const haystack = normalise([product.title, product.material, product.format, product.length, product.shortText].join(' '));
        return (!query || haystack.includes(query)) && matchesNamedFilter(product, activeFilter);
      });
      list.replaceChildren(...filtered.map(buildChoice));
      if (resultCount) resultCount.textContent = filtered.length + (filtered.length > 1 ? ' modèles disponibles' : ' modèle disponible');
      if (empty) empty.hidden = filtered.length > 0;
    };

    const persist = () => {
      if (designMode) return;
      try { window.localStorage.setItem(storageKey, JSON.stringify(state.filter(Boolean))); } catch (error) {}
      const url = new URL(window.location.href);
      const selected = state.filter(Boolean);
      if (selected.length) url.searchParams.set('compare', selected.join(','));
      else url.searchParams.delete('compare');
      window.history.replaceState({}, '', url.toString());
    };

    const closeDrawer = () => {
      if (!layer || layer.hidden) return;
      layer.hidden = true;
      document.body.classList.remove('mc-comparator-is-open');
      if (lastTrigger) {
        lastTrigger.setAttribute('aria-expanded', 'false');
        lastTrigger.focus();
      }
    };

    const selectProduct = (handle) => {
      if (!productByHandle.has(handle)) return;
      if (state.some((value, index) => index !== activeSlot && value === handle)) return;
      state[activeSlot] = handle;
      render(true);
      persist();
      closeDrawer();
    };

    const openDrawer = (slot, trigger) => {
      if (!layer || !drawer) return;
      activeSlot = slot;
      lastTrigger = trigger;
      activeFilter = 'all';
      root.querySelectorAll('[data-filter]').forEach((button) => button.classList.toggle('is-active', button.dataset.filter === 'all'));
      if (search) search.value = '';
      renderChoices();
      layer.hidden = false;
      document.body.classList.add('mc-comparator-is-open');
      trigger.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => (search || drawer).focus(), 30);
    };

    root.querySelectorAll('[data-change-model]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', () => openDrawer(Number(button.closest('[data-slot]').dataset.slot), button));
    });
    root.querySelectorAll('[data-close-drawer]').forEach((button) => button.addEventListener('click', closeDrawer));
    if (search) search.addEventListener('input', renderChoices);
    if (differenceToggle) differenceToggle.addEventListener('change', updateDifferenceRows);

    root.querySelectorAll('[data-filter]').forEach((button) => {
      if (button.dataset.filter !== 'all') button.hidden = !products.some((product) => matchesNamedFilter(product, button.dataset.filter));
      button.addEventListener('click', () => {
        activeFilter = button.dataset.filter;
        root.querySelectorAll('[data-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
        renderChoices();
      });
    });

    const reset = root.querySelector('[data-reset-comparison]');
    if (reset) reset.addEventListener('click', () => {
      state.splice(0, state.length, ...defaults.slice(0, 3));
      products.forEach((product) => { if (state.length < 3 && !state.includes(product.handle)) state.push(product.handle); });
      while (state.length < 3) state.push(null);
      render(true);
      persist();
      closeDrawer();
    });

    const copyButton = root.querySelector('[data-copy-comparison]');
    if (copyButton) copyButton.addEventListener('click', async () => {
      persist();
      const original = copyButton.textContent;
      try {
        await navigator.clipboard.writeText(window.location.href);
        copyButton.textContent = 'Lien copié';
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = window.location.href;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        input.remove();
        copyButton.textContent = 'Lien copié';
      }
      window.setTimeout(() => { copyButton.textContent = original; }, 1800);
    });

    if (drawer) drawer.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(drawer.querySelectorAll('button:not([disabled]):not([hidden]),input:not([disabled]),a[href]')).filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      }
      if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    render(false);
  }

  const initAll = (scope) => scope.querySelectorAll('[data-comparator-root]').forEach(initComparator);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
